/** `/content/series/:showId` or `/content/series/:showId/seasons/:seasonId`. */
const TV_SHOW_DETAILS_PATH = /^\/content\/series\/(\d+)(?:\/seasons\/\d+)?$/

export const seasonDetailsPath = (showId: number, seasonId: number | string) =>
  `/content/series/${showId}/seasons/${seasonId}`

export const isTvShowDetailsPathForShow = (
  pathname: string | null | undefined,
  showId: number | string
): boolean => {
  const match = pathname?.match(TV_SHOW_DETAILS_PATH)
  return match != null && Number(match[1]) === Number(showId)
}
